import React, { useEffect } from 'react'
import { Dialog ,Box,Typography,List,ListItem,} from '@mui/material'
import { qrCodeImage } from '../Statics/Data'
import styled from '@emotion/styled'
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";
import { useChatContex } from '../../contex/ChatContex';
import ChatDilog from '../chat/ChatDilog';
import { AddUser } from '../../server/Server';
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';


function LogindilogBox() {


const DilogStyle={
   height:'96%',
   marginTop:'12%',
   width:"60%",
   maxWidth:'100%',
   maxHeight:'100%',
   boxShadow:'none',
   overflow:'hidden',
}

const Containers=styled(Box)`
padding:56px 0 56px 56px
`

const Qrcode=styled("img")({
    height:'264px',
    width:"264px",
    margin :'50px 0 0 50px',
    
})

const ListItems=styled(List)`
 & > li{
    padding:0;
    margin-top:15px;
    font-size:18px;
    line-height:28px;
    color:#4a4a4a;
 }
`

const Title=styled(Typography)`
font-size:26px;
color:#525252;
font-weight:300;
font-faimly:inherit;
margin-bottom:25px

`
const Components=styled(Box)`
display:flex;

`

const {login}=useChatContex()


const {loginData}=useChatContex()

const onSuccess=(res)=>{
    const decode =jwt_decode(res.credential)
    loginData(decode)
    AddUser(decode)
    
}

const onError=(res)=>{
    console.log(res)
}











    return (
        <>
            <Dialog
        open={true}
        PaperProps={{sx:DilogStyle}}
        hideBackdrop={true}
        >

        <Components>
            <Containers>
               <Title>To use WhatsApp on your computer</Title>
               <ListItems>
                  <ListItem>1. Opne Whatsup on your phone</ListItem>
                  <ListItem>2. Tap Menu or Setting and Select Linked Device</ListItem>
                  <ListItem>3. Point ypur phone to this screen to capture the code</ListItem>
               </ListItems>
            </Containers>
            <Box style={{position:"relative"}}>
               <Qrcode  src={qrCodeImage} alt="qr code" />
               <Box style={{position:"absolute",top:"50%",transform:'translateX(20%)'}}>
                <GoogleLogin 
                    onSuccess={onSuccess}
                    onError={onError}
                />
                </Box>
            </Box>
           
        </Components>
            
        </Dialog>
        <ToastContainer/>
        </>
    )
}

export default LogindilogBox
